import { v1 as uuidv1 } from 'uuid'
import React, { Component } from 'react'
import { Typography, Box, Grid, TextField } from '@material-ui/core'
import { validate } from 'class-validator';
import { CropComponent } from './crop';
import Crop from '../model/crop';
import InsuranceApplication from '../model/insurance-application';
import ApplicationValue from '../model/application-value';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios, { AxiosResponse } from 'axios'

interface ICropsProps {
    data: InsuranceApplication;
    onDataChange: any;
    renderButtons: any;
    nextClick: any;
    prevClick: any;
    disabled: boolean | undefined;
}

export class CropsForm extends Component<ICropsProps, any> {

    constructor(props: ICropsProps) {
        super(props);
        this.state = {

            applicationValues: props.data.applicationValues,
            errors: new Array(props.data.crops.length),
            cropFormErrors: [],
            crops: []
        };

        let now = new Date();
        const offset = now.getTimezoneOffset();
        now = new Date(now.getTime() + (offset * 60 * 1000));
        const dateString = now.toISOString().split('T')[0];

        const options = {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        }

        axios.get(`https://online.sagabrokers.pl/agro/CropDefinitions?date=${dateString}`, options).then((response: AxiosResponse<any>) => {
            if (response.status === 200) {
                this.setState({
                    form: props.data.crops,
                    crops: response.data.map((crop: any) => { return crop.CropName })
                });
            }
        });
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleCropChange() {

    }

    handleAreaChange = (event: any) => {
        let applicationValues = this.state.applicationValues as ApplicationValue[];
        let av: ApplicationValue | undefined;
        av = applicationValues.find(p => p.key === event.target.name);


        let selectedIndex = null;
        let val = event.target.value.replace(/\s+/g, '');
        let value = val.replace(/,/, '.');

        if (av === undefined) {
            av = new ApplicationValue(event.target.name, value, selectedIndex);
            applicationValues.push(av);
        } else {
            av.selectedIndex = selectedIndex;
            av.value = value;
        }

        this.setState({
            applicationValues: applicationValues
        });
    }


    next = async () => {
        let result = await this.validateForm();
        if (result) {
            this.props.onDataChange(this.getData());
            this.props.nextClick();
        } else {
            window.scrollTo(0, 0);
        }
    }

    previous = () => {
        this.props.onDataChange(this.getData());
        this.props.prevClick();
    }

    getData = (): any => {
        return { crops: this.state.form, applicationValues: this.state.applicationValues };
    }

    getValue = (key: string): string => {
        let av = (this.state.applicationValues as ApplicationValue[]).find(p => p.key === key);
        return av ? av.value.replace(/\./g, ',') : '';
    }

    validateForm = async (): Promise<boolean> => {

        const crops: Crop[] = this.state.form;
        let errors: any[] = [];
        let cropFormErrors = [];
        let valid: boolean = true;

        let cpgo = (this.state.applicationValues as ApplicationValue[]).find(p => p.key.startsWith('calkowita_powierzchnia_gruntow'))
        if (!cpgo || (cpgo && (isNaN(Number(cpgo.value)) || isNaN(parseInt(cpgo.value))))) {
            valid = false;
            cropFormErrors.push('calkowita_powierzchnia_gruntow');
        } else {
            let cpgoVal: number = cpgo ? parseInt(cpgo.value) : 0;

            if (cpgoVal <= 0) {
                valid = false;
                cropFormErrors.push('calkowita_powierzchnia_gruntow');
            }
        }

        for (let i = 0; i < crops.length; i++) {
            let validationErrors = await validate(crops[i]);

            let cropErrors = validationErrors.map((element) => {
                if (element.children.length === 0)
                    return element.property;
                else
                    return element.children.map((child) => { return element.property + '.' + child.property })
            }).flat();

            if (crops[i].insuranceCoverage.findIndex(p => p.key.startsWith('zakres_ubezpieczenia')) < 0)
                cropErrors.push('zakres_ubezpieczenia');
            if (crops[i].insuranceCoverage.findIndex(p => p.key.startsWith('udzial_wlasny')) < 0)
                cropErrors.push('udzial_wlasny');
            if (crops[i].insuranceCoverage.findIndex(p => p.key.startsWith('minimalna_wysokosc_szkody')) < 0)
                cropErrors.push('minimalna_wysokosc_szkody');

            errors.push(cropErrors);
            if (cropErrors.length > 0) {
                valid = false;
                crops[i].id = uuidv1();
            }
        };

        this.setState({
            form: this.state.form,
            errors: errors,
            cropFormErrors: cropFormErrors
        });

        return valid;
    }

    hasError = (fieldName: string): boolean => {
        return (this.state.cropFormErrors as string[]).findIndex(p => p.startsWith(fieldName)) >= 0;
    }

    addCrop = () => {
        let form = this.state.form;
        form.push(new Crop());

        let errors = this.state.errors;
        errors.push([]);

        this.setState({
            form: form,
            errors: errors
        });
    }

    delete = (id: any) => {

        let index = this.state.form.findIndex((crop: Crop) => {
            return crop.id === id
        });

        if (index >= 0) {
            this.state.form.splice(index, 1);
            this.setState({ form: this.state.form });
        }

    }

    crops() {
        return this.state.form ? this.state.form.map((crop: Crop, index: any) => (
            <CropComponent
                key={crop.id}
                index={index}
                numberOfCrops={this.state.form.length}
                data={crop}
                errors={this.state.errors[index]}
                onDataChange={this.handleCropChange}
                onDelete={this.delete}
                disabled={this.props.disabled}
                crops={this.state.crops}
            />
        )) : null;
    }

    render() {
        return (
            <>
                <Box marginBottom={3}>
                    <Typography variant="h5" align="center" gutterBottom={true}>Uprawy i zakres ubezpieczenia</Typography>
                </Box>
                {
                    this.state.errors.length > 0 && this.state.errors.find((p: any) => p !== undefined) ?
                        <>
                            <Alert severity="error">
                                <AlertTitle>Uwaga</AlertTitle>
                                <p>Pola zaznaczone na czerwono są obowiązkowe. Wypełnij je, aby przejść dalej.</p>
                            </Alert>
                            <Typography variant="h5" gutterBottom={true}>&nbsp;</Typography>
                        </>
                        : null

                }
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={12}>
                        <TextField error={this.hasError('calkowita_powierzchnia_gruntow')} disabled={this.props.disabled} id="calkowita_powierzchnia_gruntow" label="Całkowita powierzchnia gruntów ornych w gospodarstwie (w ha)" name="calkowita_powierzchnia_gruntow"
                            value={this.getValue('calkowita_powierzchnia_gruntow')} variant="outlined" margin="normal" fullWidth onChange={this.handleAreaChange}
                        />
                    </Grid>
                </Grid>
                <Typography variant="h5" gutterBottom={true}>&nbsp;</Typography>
                {this.crops()}
                {this.props.renderButtons({ caption: 'Dalej', click: this.next }, { caption: 'Wstecz', click: this.previous }, this.addCrop)}
            </>
        )
    }

}
